import pinia from '@/stores';
import { useAuthorityStore } from '@/stores/authority';
import cookies from 'js-cookie';
import wx from 'weixin-js-sdk';
import { isWxWork, isWeixin } from '@/utils/common/device-util';

const useAuthority = useAuthorityStore(pinia);

/**
 * 清除权限信息
 */
const clearAuthInfo = () => {
  useAuthority.setLoginInfo(null);

  useAuthority.setLoginInfoAndFunction({
    loginInfo: null,
    functionList: null,
    originalFunctionList: null,
    authorityCodeList: null,
    personalFunctionList: null,
  });

  cookies.remove('userType');
  cookies.remove('UToken');
};

/**
 * 退出登录
 */
const redirectLogOut = () => {
  clearAuthInfo();
  const pathName = window.location.pathname;
  const returnUrl = encodeURI(
    pathName + window.location.search + window.location.hash,
  );

  // 异域名登录页
  window.location.href = `/login${pathName !== '/' ? `?returnUrl=${returnUrl}` : ''}`;
};

/**
 * 退出登录（移动端）
 */
const redirectMobileLogOut = () => {
  // eslint-disable-next-line no-underscore-dangle
  if (window.__wxjs_environment === 'miniprogram') {
    // 如果是移动端的小程序环境，则退出到小程序登录页
    const { corpId } = useAuthority;
    wx.miniProgram.navigateTo({
      url: `/pages/home/Logout?fromType=logout${corpId ? `&corpId=${corpId}` : ''}`,
      success: () => {},
    });
  } else {
    redirectLogOut();
  }
};

/**
 * 是否转到微信/企业微信的消息中转
 */
const isRedirectWxMessageTransfer = (to) => {
  if (
    to.meta?.layout === 'front' &&
    to.meta?.redirectType &&
    (isWxWork() || isWeixin())
  ) {
    return true;
  }
  return false;
};

/**
 * 转到微信/企业微信的消息中转
 */
const redirectWxMessageTransfer = (to) => {
  const newQuery = to.query;
  newQuery.type = to.meta?.redirectType;
  const searchParams = new URLSearchParams(Object.entries(newQuery));
  const webUrl = import.meta.env.VITE_WEB_URL;
  const replaceUrl = `${webUrl}/message/redirect?${searchParams.toString()}&t=${Date.now()}`;
  window.location.replace(replaceUrl);
};

export {
  redirectLogOut,
  redirectMobileLogOut,
  clearAuthInfo,
  isRedirectWxMessageTransfer,
  redirectWxMessageTransfer,
};
